import { useEffect } from 'react';
import { graphql } from 'react-relay';

import { useMutationInterop } from '@confluence/apollo-relay-interop/entry-points/useMutationInterop.ts';

import type {
	DeleteContentMutation as DeleteContentMutationData,
	DeleteContentMutationVariables,
} from './__types__/DeleteContentMutation.ts';
import { ContentDeleteActionType } from './__types__/DeleteContentMutation.ts';

export type UseHandleDeleteCreatedDraft = {
	createdDraftId: string | null;
	setCreatedDraftId: (id: null) => void;
	isCreatingDraftCancelled: boolean;
	setIsCreatingDraftCancelled: (val: boolean) => void;
	subType: string;
};

export const useHandleDeleteCreatedDraft = ({
	createdDraftId,
	setCreatedDraftId,
	isCreatingDraftCancelled,
	setIsCreatingDraftCancelled,
	subType,
}: UseHandleDeleteCreatedDraft): void => {
	const [deleteContentMutation] = useMutationInterop<
		DeleteContentMutationData,
		DeleteContentMutationVariables
	>(graphql`
		mutation useHandleDeleteCreatedDraftMutation(
			$contentId: ID!
			$action: ContentDeleteActionType!
		) {
			deleteContent(contentId: $contentId, action: $action) {
				contentId
				wasDeleted
			}
		}
	`);

	useEffect(() => {
		if (createdDraftId && isCreatingDraftCancelled) {
			const executeDeleteDraft = async () => {
				try {
					setCreatedDraftId(null);
					setIsCreatingDraftCancelled(false);
					await deleteContentMutation({
						variables: {
							contentId: createdDraftId,
							action: ContentDeleteActionType.DELETE_DRAFT,
						},
					});
				} catch (e) {
					return e;
				}
			};

			void executeDeleteDraft();
		}
	}, [
		createdDraftId,
		setCreatedDraftId,
		isCreatingDraftCancelled,
		setIsCreatingDraftCancelled,
		subType,
		deleteContentMutation,
	]);
};
